import { PlayerPosition, ClientGameState } from '@hokm/shared';
import { getPlayerPositions, getTrickOffsets, PlayerPositionConfig } from '../../../config/positions';

/**
 * Convert server position to display position.
 * Server positions are absolute (0-3 based on join order).
 * Display positions are relative: local player always at SOUTH (bottom).
 */
export function toDisplayPosition(
  serverPosition: PlayerPosition,
  myPosition: PlayerPosition,
  playerCount: number
): PlayerPosition {
  if (playerCount === 2) {
    // 2P: Server uses positions 0 and 2 (South and North)
    // Display: me at South, opponent at North
    return serverPosition === myPosition ? PlayerPosition.SOUTH : PlayerPosition.NORTH;
  }

  if (playerCount === 3) {
    // 3P: Server uses positions 0, 1, 2 (South, West, North)
    // Use modulo 3 to rotate correctly (never returns EAST=3)
    return ((serverPosition - myPosition + 3) % 3) as PlayerPosition;
  }

  // 4P: Standard rotation with modulo 4
  return ((serverPosition - myPosition + 4) % 4) as PlayerPosition;
}

/**
 * Get position config for the current game state.
 */
export function getPositionConfigForState(state: ClientGameState | null): Record<PlayerPosition, PlayerPositionConfig> {
  const playerCount = state?.players.filter((p) => p !== null).length ?? 4;
  return getPlayerPositions(playerCount);
}

/**
 * Get trick offsets for the current game state.
 */
export function getTrickOffsetsForState(
  state: ClientGameState | null
): Record<PlayerPosition, { x: number; y: number }> {
  const playerCount = state?.players.filter((p) => p !== null).length ?? 4;
  return getTrickOffsets(playerCount);
}

/**
 * Get actual player count from state (excluding null slots).
 */
export function getPlayerCount(state: ClientGameState | null): number {
  return state?.players.filter((p) => p !== null).length ?? 4;
}
